<template>
  <g>
    <path
      d="M16.7 5.30025L18.14 3.86025C18.46 3.54025 18.23 3.01025 17.79 3.01025H11.5C11.22 3.01025 11 3.23025 11 3.51025V9.80025C11 10.2503 11.54 10.4703 11.85 10.1503L13.3 8.70025C15.27 10.1603 16.55 12.4803 16.55 15.1203C16.55 15.7803 16.47 16.4303 16.31 17.0403C16.19 17.5403 16.79 17.9003 17.15 17.5303C18.63 16.0003 19.55 13.9203 19.55 11.6203C19.55 9.11025 18.44 6.86025 16.7 5.30025Z"
    />
    <path
      d="M12.15 13.8602L10.7 15.3002C8.72995 13.8402 7.44995 11.5202 7.44995 8.88025C7.44995 8.22025 7.52995 7.57025 7.68995 6.96025C7.80995 6.46025 7.20995 6.10024 6.84995 6.47024C5.36995 8.00024 4.44995 10.0802 4.44995 12.3802C4.44995 14.9002 5.54995 17.1502 7.28995 18.7102L5.84995 20.1502C5.52995 20.4702 5.75995 21.0002 6.19995 21.0002H12.49C12.77 21.0002 12.99 20.7802 12.99 20.5002V14.2102C13 13.7702 12.46 13.5402 12.15 13.8602Z"
    />
  </g>
</template>
